import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f8f9fa;
  text-align: center;
  font-family: "Poppins", sans-serif;
`;

const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  max-width: 700px;
  width: 90%;
`;

const ErrorCode = styled.h1`
  font-size: 7rem; /* Reduced from 10rem */
  font-weight: 700;
  margin: 0;
  background: linear-gradient(45deg, #6a11cb 0%, #2575fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
  /* Removed animation */
`;

const ErrorTitle = styled.h2`
  font-size: 2.2rem;
  margin: 1rem 0;
  color: #333;
  font-weight: 600;
`;

const ErrorDescription = styled.p`
  font-size: 1.1rem;
  max-width: 600px;
  margin: 1.5rem auto 2.5rem;
  color: #666;
  line-height: 1.6;
`;

const HomeButton = styled(Link)`
  display: inline-block;
  background: linear-gradient(45deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  font-weight: 600;
  padding: 0.9rem 2rem;
  border-radius: 6px;
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(106, 17, 203, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(106, 17, 203, 0.3);
  }
  
  &:active {
    transform: translateY(1px);
  }
`;

const IllustrationContainer = styled.div`
  margin-bottom: 1.5rem;
  max-width: 100%;
  height: auto;
  position: relative;
`;

const ErrorPage = () => {
  return (
    <ErrorPageContainer>
      <ContentWrapper>
        <IllustrationContainer>
          <svg width="120" height="60" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="25" stroke="#333333" strokeWidth="4"/>
            <circle cx="90" cy="30" r="25" stroke="#333333" strokeWidth="4"/>
            <line x1="55" y1="30" x2="65" y2="30" stroke="#333333" strokeWidth="4" strokeLinecap="round"/>
            <path d="M5 30C5 30 0 30 0 20" stroke="#333333" strokeWidth="3" strokeLinecap="round"/>
            <path d="M115 30C115 30 120 30 120 20" stroke="#333333" strokeWidth="3" strokeLinecap="round"/>
          </svg>
        </IllustrationContainer>
        <ErrorCode>404</ErrorCode>
        <ErrorTitle>Page Not Found</ErrorTitle>
        <ErrorDescription>
          Oops! The page you're looking for seems to have vanished into thin air. 
          Perhaps it's trying on a new pair of frames? Let's get you back to our 
          collection of stylish eyewear.
        </ErrorDescription>
        <HomeButton to="/">Back to Home</HomeButton>
      </ContentWrapper>
    </ErrorPageContainer>
  );
};

export default ErrorPage;